module.exports = __webpack_public_path__ + "6880b7f440fee3d3d23778d295fda4fc.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Heavy.ttf
// module id = 656
// module chunks = 0